import React from 'react';
import { Link as ScrollLink } from 'react-scroll';

const TeamIntro = () => {
  return (
    <div className="container mx-auto px-4 py-8 md:py-16 text-center">
      <h2 className="text-2xl md:text-4xl font-bold text-center mb-6">Wir sind CodeStart!</h2>
      
      <p className="text-lg max-w-4xl mx-auto mb-10">
        Unsere Kurse werden von zertifizierten Lehrkräften mit langjähriger Erfahrung im Unterrichten von Kindern und Erwachsenen gehalten. 
        Die Lehrkräfte (das sind Aaricia, Hubertus und Lucas) sind auch direkt deine Ansprechpartner für Fragen, Wünsche oder Anregungen!
      </p>
      
      <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-12">
        <div className="flex flex-col items-center">
          <div className="w-48 h-48 rounded-full overflow-hidden mb-4 border-4 border-custom_tertiary">
            <img 
              src="/team_fotos/aaricia_codestart.jpg" 
              alt="Aaricia" 
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/api/placeholder/200/200";
              }}
            />
          </div>
          <h3 className="text-xl font-semibold">Aaricia</h3>
        </div>
        
        <div className="flex flex-col items-center">
          <div className="w-48 h-48 rounded-full overflow-hidden mb-4 border-4 border-custom_tertiary">
            <img 
              src="/team_fotos/hubertus_codestart.jpg" 
              alt="Hubertus" 
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/api/placeholder/200/200";
              }}
            />
          </div>
          <h3 className="text-xl font-semibold">Hubertus</h3>
        </div>
        
        <div className="flex flex-col items-center">
          <div className="w-48 h-48 rounded-full overflow-hidden mb-4 border-4 border-custom_tertiary">
            <img 
              src="/team_fotos/lucas_codestart.jpg" 
              alt="Lucas" 
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/api/placeholder/200/200";
              }}
            />
          </div>
          <h3 className="text-xl font-semibold">Lucas</h3>
        </div>
      </div>
      
      <ScrollLink
        to="contact-form-section"
        smooth={true}
        duration={800}
        offset={-100}
        className="inline-block px-8 py-3 bg-custom_tertiary text-white text-xl font-semibold rounded-full no-underline shadow-md hover:bg-custom_tertiary/80 hover:text-black transition-colors duration-300 cursor-pointer"
      >
        Sag Hallo!
      </ScrollLink>
    </div>
  );
};

export default TeamIntro;